import React, { useState, useEffect } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import { useTornaIndietro } from '../common/navigazione';
import { getMusicaById } from '../services/api';
import { Container, Card, Row, Col, Spinner, Alert, Button } from 'react-bootstrap';

const MusicaDetail = () => {
  const [musica, setMusica] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams();
  const location = useLocation();
  const backTo = location.state?.from || '/musica';
  const tornaIndietro = useTornaIndietro('/musica');

  useEffect(() => {
    const fetchMusicaData = async () => {
      try {
        setLoading(true);
        const response = await getMusicaById(id);
        setMusica(response.data);
      } catch (err) {
        setError('Errore nel caricamento della musica.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchMusicaData();
  }, [id]);

  const renderField = (label, value) => (
    <p><strong>{label}:</strong> {value || 'N/D'}</p>
  );

  if (loading) return <Spinner animation="border" />;
  if (error) return <Alert variant="danger">{error}</Alert>;
  if (!musica) return <Alert variant="warning">Musica non trovata.</Alert>;

  return (
    <Container>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Dettaglio Musica: {musica.titolo}</h2>
        <div>
          <Button variant="secondary" onClick={tornaIndietro} className="me-2">
            Torna alla Lista
          </Button>
          <Button variant="warning" as={Link} to={'/musica/edit/' + id} className="me-2">Modifica</Button>
          <Button variant="info" as={Link} to={'/musica/print/' + id}>Stampa</Button>
        </div>
      </div>

      {/* ANTEPRIMA IMMAGINE */}
      {musica.immagine_url && (
        <Card className="mb-4">
            <Card.Body className="text-center">
                <img 
                    src={musica.immagine_url.startsWith('http') ? musica.immagine_url : process.env.REACT_APP_STATIC_FILES_BASE_URL + musica.immagine_url} 
                    alt={"Copertina di " + musica.titolo} 
                    style={{ maxHeight: '300px', border: '1px solid #dee2e6' }} 
                />
            </Card.Body>
        </Card>
      )}

      {/* SCHEDA MUSICA */}
      <Card className="mb-4">
        <Card.Header>SCHEDA MUSICA</Card.Header>
        <Card.Body>
            <Row>
                <Col md={8}>{renderField('Titolo', musica.titolo)}</Col>
                <Col md={4}>{renderField('Anno', musica.anno)}</Col>
            </Row>
            {renderField('Artista', musica.artista)}
            {renderField('Genere', musica.genere)}
            {renderField('Casa di Produzione', musica.casa_di_produzione)}
            <hr />
            <p><strong>Descrizione:</strong></p><p>{musica.descrizione || 'N/D'}</p>
        </Card.Body>
      </Card>

      {/* DETTAGLI PRODOTTO */}
      <Card className="mb-4">
        <Card.Header>DETTAGLI PRODOTTO</Card.Header>
        <Card.Body>
            <Row>
                <Col>{renderField('Categoria', musica.categoria)}</Col>
                <Col>{renderField('Supporto', musica.supporto)}</Col>
            </Row>
            <Row>
                <Col>{renderField('SKU', musica.sku)}</Col>
                <Col>{renderField('Barcode', musica.barcode)}</Col>
                <Col>{renderField('Barcode IBS', musica.barcode_ibs)}</Col>
            </Row>
            {renderField('Ubicazione', musica.ubicazione)}
        </Card.Body>
      </Card>

      {/* DATI DISCOGS */}
      {(musica.discogs_id || musica.rating_discogs) && (
        <Card className="mb-4">
          <Card.Header>DATI DISCOGS</Card.Header>
          <Card.Body>
            <Row>
              <Col md={4}>{renderField('Discogs ID', musica.discogs_id)}</Col>
              <Col md={4}>{renderField('Rating Discogs', musica.rating_discogs ? `${musica.rating_discogs}/5` : 'N/D')}</Col>
              <Col md={4}>{renderField('Numero Voti', musica.rating_discogs_count)}</Col>
            </Row>
          </Card.Body>
        </Card>
      )}

      {/* PREZZI E MAGAZZINO */}
      <Card className="mb-4">
        <Card.Header>PREZZI E MAGAZZINO</Card.Header>
        <Card.Body>
            <Row>
                <Col>{renderField('Prezzo Negozio', musica.prezzo_negozio ? '€ ' + musica.prezzo_negozio.toFixed(2) : 'N/D')}</Col>
                <Col>{renderField('Prezzo IBS', musica.prezzo_ibs ? '€ ' + musica.prezzo_ibs.toFixed(2) : 'N/D')}</Col>
                <Col>{renderField('Costo Acquisto', musica.costo_acquisto ? '€ ' + musica.costo_acquisto.toFixed(2) : 'N/D')}</Col>
                <Col>{renderField('IVA', musica.iva ? musica.iva + '%' : 'N/D')}</Col>
            </Row>
            <Row>
                <Col>{renderField('Condizione', musica.condizione)}</Col>
                <Col>{renderField('Quantità', musica.quantita)}</Col>
            </Row>
            {renderField('Fornitore', musica.fornitore?.denominazione)}
        </Card.Body>
      </Card>

      {/* CATALOGO */}
      <Card className="mb-4">
        <Card.Header>CATALOGO</Card.Header>
        <Card.Body>
            {renderField('Fuori Catalogo', musica.fuori_catalogo ? 'Sì' : 'No')}
        </Card.Body>
      </Card>

      {/* WEB */}
      <Card className="mb-4">
        <Card.Header>WEB</Card.Header>
        <Card.Body>
            <p><strong>Descrizione WEB:</strong></p>
            <div dangerouslySetInnerHTML={{ __html: musica.descrizione_web || 'N/D' }} />
        </Card.Body>
      </Card>

    </Container>
  );
};

export default MusicaDetail;
